export default "__VITE_ASSET__DWDcdeJg__"